import "../assets/RealTimeInfoWindow.css";

export default function RealTimeInfoWindow({ data, stopTitle }) {
  if (!data || data.length === 0) {
    return (
      <div className="route-stop-info">
        <p>No real-time data available for this stop.</p>
      </div>
    );
  }

  try {
    const lastUpdated = data[0].lastUpdated;
    const formattedTime = new Date(lastUpdated).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return (
      <div className="route-stop-info">
        <p className="last-update">Updated at {formattedTime}</p>
        <div className="results">
          {data.map((route, idx) => (
            <div key={idx}>
              <div className={`route-${route.number}`}>
                Route {route.publicNumber} - {stopTitle} #{route.stopID}{" "}
                <i>({route.direction})</i>
              </div>
              <p className="bus-details">
                <i className="fa fa-bus"></i>
                <strong
                  style={{
                    color:
                      route.nextBus.status === "Late" ? "#ff6666" : "#9999ff",
                  }}
                >
                  {route.nextBus.status === "Late"
                    ? `Running late ${route.nextBus.scheduleDifference} mins`
                    : "On time"}
                </strong>
                <br />
                Estimated Arrival: <b>{route.nextBus.arrival}</b>
                <i>({route.nextBus.timeUntil})</i>
              </p>
              {route.nextTimes && route.nextTimes.length > 0 && (
                <p className="next bus-details">
                  Next {route.direction} estimated arrival times for this stop:
                  <br />
                  <span className="times">
                    <strong>{route.nextTimes.join(", ")}</strong>
                  </span>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  } catch (error) {
    return (
      <div className="route-stop-info">
        <p className="text-warning">
          Error displaying real-time information. Please try again.
        </p>
      </div>
    );
  }
}
